import { render } from "./InformeUso.vue?vue&type=template&id=2920c9d3&scoped=true"
import script from "./InformeUso.vue?vue&type=script&lang=js"
export * from "./InformeUso.vue?vue&type=script&lang=js"

import "./InformeUso.vue?vue&type=style&index=0&id=2920c9d3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2920c9d3"]])

export default __exports__